import { authHeaderNoContentType } from '../utils';

export const supportService = {
  create,
};

function create(request) {
  let supportRequest = {
    project: request.project,
    version: request.version,
    component: request.component,
    subject: request.subject,
    requester: {
      email: request.email,
    },
    description: request.description,
    severity: request.severity,
    type: request.type,
  };
  let data = new FormData(); // eslint-disable-line no-undef
  let blob = new Blob([JSON.stringify(supportRequest)], {
    type: 'application/json',
  }); // eslint-disable-line no-undef
  data.append('request', blob);
  if (request.attachment) {
    data.append('file', request.attachment);
  }

  const requestOptions = {
    method: 'POST',
    headers: authHeaderNoContentType(),
    body: data,
  };

  return fetch('/api/supportrequests', requestOptions).then(handleResponse);
}

function handleResponse(response) {
  if (!response.ok) {
    return Promise.reject(response.status);
  } else {
    return response.json();
  }
}



// WEBPACK FOOTER //
// ./src/services/support.service.js